import { render, staticRenderFns } from "./DetailPromo.vue?vue&type=template&id=159420d4&scoped=true"
import script from "./DetailPromo.vue?vue&type=script&lang=js"
export * from "./DetailPromo.vue?vue&type=script&lang=js"
import style0 from "./DetailPromo.vue?vue&type=style&index=0&id=159420d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159420d4",
  null
  
)

export default component.exports